import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { analytics } from './firebase-config';
import MapPage from './pages/MapPage';
import AboutPage from './pages/AboutPage';
import './App.css';

function PageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    logEvent(analytics, 'page_view', {
      page_path: location.pathname,
      page_search: location.search,
    });
  }, [location]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <PageViewTracker />
      <Routes>
        <Route path="/" element={<MapPage />} />
        <Route path="/about" element={<AboutPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
